import { Link } from "@/lib/router-compat";
import { Youtube, Twitter, Instagram, Facebook, Github, Linkedin } from "lucide-react";
import { HELP } from "@/lib/help";

const Footer = () => {
  const socialLinks = [
    { icon: Github, href: "https://neti.us/git", label: "GitHub" },
    { icon: Youtube, href: "https://neti.us/yt", label: "YouTube" },
    { icon: Twitter, href: "https://neti.us/x", label: "Twitter" },
    { icon: Facebook, href: "https://neti.us/fb", label: "Facebook" },
    { icon: Instagram, href: "https://neti.us/ig", label: "Instagram" },
    { icon: Linkedin, href: "https://neti.us/ld", label: "LinkedIn" },
  ];

  return (
    <footer className="border-t border-gray-800 bg-zinc-950">
      <div className="container px-4 sm:px-6 lg:px-8 py-12">
        {/* Support (HELP) */}
        <div className="text-center mb-8">
          <h2 className="text-xs font-medium uppercase tracking-wider text-gray-500 mb-3">
            Support
          </h2>
          <nav aria-label="Support links">
            <ul className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 text-sm text-gray-400">
              <li>
                <a
                  href={HELP.knowledgeBase}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center min-h-11 px-2 hover:text-white transition-colors duration-300"
                >
                  Knowledge Base
                </a>
              </li>
              <li aria-hidden="true">•</li>
              <li>
                <a
                  href={HELP.home}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center min-h-11 px-2 hover:text-white transition-colors duration-300"
                >
                  Help Center
                </a>
              </li>
              <li aria-hidden="true">•</li>
              <li>
                <a
                  href={HELP.submitTicket}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center min-h-11 px-2 hover:text-white transition-colors duration-300"
                >
                  Submit a Ticket
                </a>
              </li>
              <li aria-hidden="true">•</li>
              <li>
                <a
                  href={HELP.status}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center min-h-11 px-2 hover:text-white transition-colors duration-300"
                >
                  System Status
                </a>
              </li>
            </ul>
          </nav>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center gap-4 mb-8">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 rounded-full text-gray-400 hover:text-white hover:bg-gray-800 hover:scale-110 shadow-lg hover:shadow-xl transition-all duration-300"
              aria-label={social.label}
            >
              <social.icon className="h-5 w-5" />
            </a>
          ))}
        </div>

        {/* Contact Info */}
        <div className="text-center mb-6">
          <p className="text-sm text-gray-400">
            <a href="tel:323-638-4871" className="hover:text-white transition-colors duration-300">323-638-4871</a>
            {" • "}
            <a href="mailto:web@netius.com" className="hover:text-white transition-colors duration-300">web@netius.com</a>
          </p>
        </div>

        {/* Copyright and Legal */}
        <div className="text-center space-y-2">
          <p className="text-sm text-gray-400">
            Copyright © 2010 - {new Date().getFullYear()} NETIUS LLC. All rights reserved.
          </p>
          <p className="text-sm text-gray-400">
            <Link to="/tools" className="hover:text-white transition-colors duration-300">
              Free Tools
            </Link>{" "}
            •{" "}
            <Link to="/privacy" className="hover:text-white transition-colors duration-300">
              Privacy Policy
            </Link>{" "}
            •{" "}
            <Link to="/terms" className="hover:text-white transition-colors duration-300">
              Terms of Service
            </Link>{" "}
            •{" "}
            <Link to="/accessibility" className="hover:text-white transition-colors duration-300">
              Accessibility
            </Link>{" "}
            •{" "}
            <Link to="/cookies" className="hover:text-white transition-colors duration-300">
              Cookie Policy
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
